import {Component, Injector, OnInit} from "@angular/core";
import {BasePageComponentDirective} from "../../_shared/base/base-page.component";
import {UserService} from "../dashboard/services/user.service";
import {ParameterService} from "../../_services/parameter.service";
import {ConfirmationDialog} from "../../_shared/dialog/confirmation.dialog";
import {FileStorageService} from "../../_services/filestorage.service";
import {UploadCeuCreditModal} from "./modals/upload-ceu-credit.modal";

@Component({
    selector: 'my-wallet-ceu',
    templateUrl: './wallet-ceu-list.component.html',
})
export class WalletCeuListComponent extends BasePageComponentDirective<any> implements OnInit {
    userCEUs: any[] = [];
    docTypes: any = {};
    populate = true;
    constructor(
        injector: Injector,
        private userService: UserService,
        private parameterService: ParameterService,
        private fileStorageService: FileStorageService,
    ) {
        super(injector);
    }
    query(): void {
        this.pageQuery.sortBy = 'id';
        this.pageQuery.sortOrder = 'desc';

        this.pageQuery.columns = ['title'];
        this.populate = true;
        this.userService.getUserCEUs(this.pageQuery).then(r => {
            this.userCEUs = r.content;
            this.page.emit(r);
            this.populate = false;
        });
    }

    override async ngOnInit(): Promise<void> {
        super.ngOnInit();
        this.docTypes = await this.parameterService.getParameterByName("DOCUMENT_TYPE");

        this.query();
    }

    downloadCert(d: any) {
        this.fileStorageService.getCertificationDocumentUrl(d.documentId, d.fileName);
    }

    deleteCert(d: any) {
        const screenWidth = window.innerWidth;
        const dialogWidth = screenWidth < 768 ? '90vw' : '800px';
        const dialog = this.dialog.open(ConfirmationDialog, {
            width: dialogWidth,
            maxWidth: '100%',
            data: {
                buttonOkLabel: 'Yes, Delete',
                buttonCancelLabel: 'Cancel',
                message: ``,
                subMessage: `Are you sure you want to delete "${d.certificationTitle}" from your wallet? This action cannot be undone.`
            }
        })

        dialog.componentInstance.result.subscribe(r => {
            if(r) {
                this.fileStorageService.deleteCertificationDocument(d.documentId).then(_ => {
                    this.query();
                    this.snackBar.open('Document deleted successfully', null, {
                        duration: 3000,
                        verticalPosition: 'top',
                        horizontalPosition: 'right'
                    });
                })
            }
        });
    }

    viewCert(d: any) {
        console.log(d);
        this.router.navigate([`/my-wallet/ceu/${d.documentId}/view`]).then()
    }

    editCertNew(d: any) {
        this.router.navigate([`/my-wallet/ceu/${d.documentId}/edit`]).then()
    }

    editCert(d: any) {
        const screenWidth = window.innerWidth;
        const dialogWidth = screenWidth < 768 ? '90vw' : '800px';
        const dialog = this.dialog.open(UploadCeuCreditModal, {
            width: dialogWidth,
            maxWidth: '100%',
            data: {
                mode: 'edit',
                documentId: d.documentId,
                certificationId: d.certificationId,
                documentType: d.documentType,
                activity: d.providerActivityId,
                earnedCredit: d.earnedCredit,
                activityResponse: d.activityResponse
            }
        });

        dialog.componentInstance.result.subscribe(r => {
            if(r) {
                this.query();
            }
        })
    }

}
